import { styled } from "@mui/material/styles";

import Button from "../../Form/Button";

export const AddBranchButton = styled(Button)(() => ({
  border: "1px solid #308CDB",
  marginLeft: "8px",
  "&:disabled": {
    color: "#D0D5DD",
    border: "1px solid #D0D5DD",
  },
}));

export const BranchText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "150%",
  color: "#465869",
}));

export const RegisteredBranchesContainer = styled("div")(() => ({
  borderLeft: "1px solid #E4E7EC",
  paddingLeft: "16px",
  marginLeft: "16px",
  height: "16px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
}));

export const RegisteredBranchesText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "150%",
  color: "#3F6280",
}));

export const RegisteredBranchesBadge = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "2px 8px",
  width: "24px",
  height: "24px",
  background: "#308CDB",
  borderRadius: "20px",
}));

export const RegisteredBranchesCounter = styled("span")(() => ({
  fontFamily: "Poppins",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "18px",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  color: "#FFFFFF",
}));
